module.exports = __webpack_public_path__ + "static/media/lloyd_metals.bb888524.svg";